import React, { useState, useEffect } from "react";

const year = new Date().getFullYear();

const FOOTER_HEIGHT = 48;

const Footer = () => {
  return (
    <footer className="app-footer" style={{ height: FOOTER_HEIGHT }}>
      © {year} 삼성중공업
    </footer>
  );
};

export default Footer;
